import type { BetterFetch } from "@better-fetch/fetch";
import type { Store } from "@di-devs/better-feature/types";
import { atom } from "nanostores";

/**
 * Simplified member visit plugin - only essential endpoints
 */
export function createMemberVisitPlugin($fetch: BetterFetch, $store?: Store) {
	return {
		atoms: {
			$lastVisit: atom<any | null>(null),
			$isVisitRecording: atom<boolean>(false),
			$visitError: atom<string | null>(null),
		},
		actions: {
			async recordVisitByBarcode(data: {
				memberCode: string;
				isMemberVisit?: boolean;
			}) {
				const visitRecord = await $fetch("/members/barcode", {
					method: "POST",
					body: data,
				});
				$store?.atoms?.$lastVisit.set(visitRecord);
				return visitRecord;
			},
			async recordVisitByQRCode(data: { memberId?: number }) {
				const visitRecord = await $fetch("/visits/qr-code", {
					method: "POST",
					body: data,
				});
				$store?.atoms?.$lastVisit.set(visitRecord);
				return visitRecord;
			},
		},
	};
}
